// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1WvuT","notes":"Notes_notes__wNls1","note":"Notes_note__3dUjA","markdown":"Notes_markdown__1yW1B"};